<div *ngIf="refund; else noRefund">
    <h1 class="refund-warning">Возврат {{refund.number}}</h1>
    <mat-tab-group animationDuration="10ms">

        <mat-tab>

            <ng-template mat-tab-label>
                <span [matBadge]="refund.totalAmount" matBadgeOverlap="false">
                    <mat-icon>info </mat-icon> 
                </span>
            </ng-template>

            <ng-template matTabContent>

                <app-refund-edit-info [order]="orderInfo"></app-refund-edit-info>

            </ng-template>

        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon>shopping_cart</mat-icon>
            </ng-template>
            <!-- <ng-template matTabContent> -->
            <app-edit-order-select-goods-plain-component [client]="buypoint">

            </app-edit-order-select-goods-plain-component>
            <!-- </ng-template> -->
        </mat-tab>

        <mat-tab>
            <ng-template mat-tab-label>
                <mat-icon>done</mat-icon>
            </ng-template>
            <div class="tab-container">
                <h2>Действия</h2>
                <app-refund-button-commit [mode]="'delete'" class="air" [refund]="refund" (refundChange)="refundChanged()"></app-refund-button-commit>
                <app-refund-button-commit [mode]="'commit'"  class="air" [refund]="refund"  (refundChange)="refundChanged()"></app-refund-button-commit>
            </div>
        </mat-tab>

        <mat-tab *ngIf="isAdmin">
            <ng-template mat-tab-label>
                <mat-icon style="color: blueviolet;">menu</mat-icon>
            </ng-template>
            <mat-accordion>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Возврат
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <pre>{{refund | json}}</pre>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            ТТ
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <pre>{{buypoint | json}}</pre>
                </mat-expansion-panel>

                <mat-expansion-panel>
                    <mat-expansion-panel-header>
                        <mat-panel-title>
                            Заказ
                        </mat-panel-title>
                    </mat-expansion-panel-header>
                    <pre>{{orderInfo | json}}</pre>
                </mat-expansion-panel>

            </mat-accordion>

        </mat-tab>

    </mat-tab-group>

</div>



<ng-template #noRefund>

    <h2 *ngIf="!returnCur.loading" style="color: red;">Возврат не найден</h2>
</ng-template>